export default __webpack_public_path__ + "static/Agrandir-Regular-f6989f3c91531a60d5ff29128f7b63c7.woff2";